import React, { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useVideoDetailsPath } from '../../../hooks/use-video-details-path';
import Colours from '../../../design-system/colours';

interface OvVideoLinkProps {
  videoId: string;
  children: ReactNode;
}

const OvVideoLink: FC<OvVideoLinkProps> = ({ videoId, children }) => {
  const getDetailsPath = useVideoDetailsPath();

  return <StyledLink to={getDetailsPath(videoId)}>{children}</StyledLink>;
};

export default OvVideoLink;

const StyledLink = styled(Link)`
  color: ${Colours.OV_ACCENT_BLUE};
  font-weight: bold;
`;
